import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Text } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'
import SprintaTips from '../../../../../SPRINTA/molecules/SprintaTips'

import { saveExperience } from '../../_utils'


class Title extends Component {
    inputRefs = {}

    
    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        if(this.hasFieldError[name] && this.hasFieldError[name]()) return;
        
        const form = {}
        form[name] = this.props.data.experience[name]

        let async = saveExperience(this.props.token, form)
        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        title: () => {
            if(!this.props.data.experience.title) {
                let error = 'Campo obrigatório'
                this.refs['title'].setError(error)
                return {
                    element: this.refs['title'].refs.input,
                    error
                }
            }

            return false
        }
    }


    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    inStep() {
        let { title } = this.props.data.experience
        return title ? true  : false
    }

    render() {
        return (
            <ContentInfo
                title='Como se chamará sua experiência?'
                description='Seja breve, detalhista e demonstre entusiasmo.
                Crie um título sucinto mas chamativo, que atraia participantes para sua experiência'
                steps={this.props.steps}
                >

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual o título da sua experiência?
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <SprintaTips>
                                Escreva um título que descreva sua principal atividade para que os participantes tenham uma ideia do que farão. Considere usar verbos de ação e tornar o título único, para que sua experiência se destaque.
                            </SprintaTips>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Text
                                label='Qual o título da sua experiência?'
                                maxLength={100}
                                name="title"
                                ref={'title'}
                                value={this.props.data.experience.title || ''}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                onChange={e => this.handleChange(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

            </ContentInfo>
        )
    }

}

export default Title


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/Title/index.js